import React, { useEffect, useState } from "react";
import { Autocomplete, Button, Dialog, FormControl } from "@mui/material";
import { DialogContent, Divider, Stack, Typography } from "@mui/material";
import { InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Toast } from "../../components/components/Toast";
import ClipLoader from "react-spinners/ClipLoader";
import Repo from "../../Repository/Repo";
import CustomInput from "../../components/components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import {  getLedgersNamesPayment } from "../../components/ledgers/ledgersNamesSlice";
import useGetPayments from "./useGetPayments";
import { getLedgerDetail} from "../../components/ledgers/detailSlice"
import { ConstructionOutlined } from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";

function AddPayment({ onClose,  banks = [] , payments}) {
  console.log("banks:", banks);

  const dispatch = useDispatch();
  const { detail } = useSelector((state) => state.ledgerDetail);
  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  const [loading, setLoading] = useState(false);
  const [selectedAccountNumber,  setSelectedAccountNumber] = useState(0);
console.log('leder', ledgersNames)
console.log('det', detail);
  const [state, setState] = useState({
    bankName: "",
    balance: "",
    amount: 0,
    ledgerId: "",
    type: "Cash",
    depositTo: "",
    accountNumber: "",
    name:"",
    mode:"",
    detail:"",
    ledgerTotal:""

  });
  console.log('stateee', state)

  console.log('modee', state.mode)
  console.log('total', state.ledgerTotal)

  // const [payments, setPayments] = useState([]);
 const userName = localStorage.getItem("username");
  console.log("state:", state);
  useEffect(() => {
    if (ledgersNames.length == 0) {
      dispatch( getLedgersNamesPayment());
    }
  }, []);
console.log('depositTo', state.depositTo);
  const handleInput = (e) => {
    const { name, value } = e.target;

    console.log('vvv',value)
    // if(name == "mode") {
    //   dispatch(getLedgerDetail({type:value,id:state.ledgerId}))
    // }
    const selectedBank = e.target.value;
    console.log("ssssss',selectedBank" , selectedBank);
    setSelectedAccountNumber(selectedBank.accountNumber);
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = (arg) => {
    setState((prev) => ({ ...prev, [arg]: "" }));
  };

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };
  const handleLedger = (e, val) => {
    // const { name, value } = e.target;
  
 
    console.log('val', val)

    setState((prev) => ({ ...prev, ledgerId: val._id , ledgerName:val.name ,ledgerTotal:val }));
  };
  
  const paymentCashBankHandler = async(id)=> {
    console.log('id', id)

    let method = state.type === "Cash" ? "paymentyByCashInHand" : "paymentByBank"
    const currentDate = new Date();
    const unixTimestamp = Math.floor(currentDate.getTime() / 1000);


    // Extract day, month, and year
    // const day = String(currentDate.getDate()).padStart(2, '0'); // Ensures two digits
    // const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    // const year = currentDate.getFullYear();
    
    // // Format the date as dd-mm-yyyy
    // const formattedDate = `${day}-${month}-${year}`;
    
    console.log(unixTimestamp );
    let { data } = await Repo.banks({
      request: {
      method: method,
      data: {
          company_code:  localStorage.getItem("companyCode"),
          ledgerId: state.ledgerId,
          credit:0,
          debit:  Number(state.amount),
          paymentId: id,
          from: userName,
          to:  state.type == "Cash" ? "cashInHand" : state?.depositTo?.bankName,
          description: state.detail,
          bankId:state?.depositTo?._id,
         date:unixTimestamp 

      }
    }
    });
 
    console.log('dataa', data)
  }
  const handleSubmit = async () => {
    console.log('stateee', state)
    try {
      if (!state.ledgerId) {
        Toast("info", "Select ledger");
        return;
      }
      if (!state.amount) {
        Toast("info", "Enter amount");
        return;
      }
      setLoading(true);
      const unixTimestamp = Math.floor(Date.now());
      console.log(unixTimestamp);
      
      const date = new Date(unixTimestamp * 1000); // Multiply by 1000 to convert seconds to milliseconds
      console.log(date);
      
      const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero if needed
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = today.getFullYear();
        return `${day}-${month}-${year}`;
    };      
        let randomNo = uuidv4()
 let method = state.mode === "purchase" ? "updatePurchaseLedger" : "updateSaleLedger"
      let { data } = await Repo.payment({
        request: {
          method: "savePayment",
          data: {
            company_code: localStorage.getItem("companyCode"),
            ledgerId: state.ledgerId,
            // ledgerName:state.ledgerName,
            user_id: localStorage.getItem("email"),
            receiver:state.mode == "purchase" ? state.ledgerName : userName,
            payer: state.mode == "purchase" ? userName : state.ledgerName,
            type: state.type,
            amount: state.amount,
            account_number: selectedAccountNumber,
            paymentMode:state.mode,
            srNum: randomNo,
            bankId:state?.depositTo?._id,
            balance:state?.balance
          },
        },
      });
      console.log("data:", data);
      console.log("data:",   data.response.status.statusCode );
      const res = data.response.status.statusCode
      await res;
      const paymentId = data.response.data['id ']

      setLoading(false);
   console.log('payment', paymentId)
   if(state.mode == "purchase") {
     await paymentCashBankHandler(paymentId)

   } else if(state.mode == "sale") {
    let paymentInCashInHandMethod = state.type === "Cash" ? "paymentsInCashInHand" : "paymentsInBanks"
    let bankMethod = state.type === "Cash" ? "" : "bankId"
 
 
    let { dataPayment } = await Repo.banks({
     
     request: {
     method: paymentInCashInHandMethod,
     data: {
         company_code:localStorage.getItem("companyCode"),
         ledgerId: state.ledgerId,
         credit: Number(state.amount),
         debit: 0,
         paymentId: paymentId,
         from: userName,
         to:  state.type == "Cash" ? "cashInHand" : state?.depositTo?.bankName,
         description: state.detail,
         date:  getCurrentDate(),
         [bankMethod]:state?.depositTo?._id,
     }
   }
   });
 
   console.log('datapaymetn', dataPayment)
   }
   
   
   
      let methodtype = state.mode === "purchase" ? "purchase" : "sale";
      const ledgerResponse = await Repo.ledger({
        request: {
          method: method,
          data: {
            [methodtype]: {
              srNum: randomNo,
              date: unixTimestamp,
              detail: state.detail,
              totalAmount: 0,
              depositedAmount: state.amount,
              remainingAmount: 0 - Number(state.amount)
            },
            _id: state.ledgerId,
          },
        },
      });
  
      console.log("Ledger Response:", ledgerResponse);
  
      if (ledgerResponse && ledgerResponse.data && ledgerResponse.data.response.status.statusCode === 200) {
        Toast("success", "Payment added");
        payments();
        onClose();
      } else {
        console.error("Failed to update ledger", ledgerResponse);
        Toast("error", "Failed to update ledger");
      }
      // onSuccess(state);
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };



  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing="24px">
          <Stack width="100%">
            <Typography
              sx={{
                color: "#4CAF50",
                fontSize: "15px",
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              Add New Payment
            </Typography>
            <Divider sx={{ mt: "16px", color: "#afafaf" }} />
          </Stack>

       


          <Autocomplete
            autoFocus
            size="small"
            value={state.ledgerName}
            onChange={(e, val) => {
              handleLedger(e, val);
            }}
            fullWidth
            getOptionLabel={(option) => option?.name || ""}
            options={ledgersNames}
            renderInput={(params) => (
              <TextField autoFocus {...params} label="Select Ledger" />
            )}
          />
            {(state?.ledgerName && state.mode ) && (
                <>
           <Typography>Balance</Typography>
           <CustomInput   
           name="amount"
           type="number"
           sx={{marginTop:"0px !important"}}
          //  label="Account No"
           disabled={true}
            value={state.mode == "sale" ? state?.ledgerTotal?.saleTotal : state?.ledgerTotal?.purchaseTotal }>
            </CustomInput>
            </>
              )}
     
          
     <FormControl fullWidth size="small">
            <InputLabel>Ledger Type</InputLabel>
            <Select
              name="mode"
              value={state.mode}
              label="Select Ledger Type"
              onChange={handleInput}
            >
              <MenuItem value="sale">Sale Khata</MenuItem>
              <MenuItem value="purchase">Purchase Khata</MenuItem>
              <MenuItem value="others">Others</MenuItem>

            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel>Select Transaction Mode</InputLabel>
            <Select
              name="type"
              value={state.type}
              label="Select Transaction Mode"
              onChange={handleInput}
            >
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="Bank">Bank</MenuItem>
            </Select>
          </FormControl>

          {state.type == "Bank" && (
            <FormControl fullWidth size="small">
              <InputLabel>Bank Name</InputLabel>
              <Select
                size="small"
                name="depositTo"
                value={state.depositTo}
                label="Bank Name"
                onChange={handleInput}
              >
                {banks.map((item, i) => {
                  return (
                    
                    <MenuItem key={i} value={item}>
                      {item.bankName}
                    </MenuItem>
                    
                  );
                })}
              </Select>
            </FormControl>
          )}
              {state.type == "Bank" && (
                <>
           <Typography>Account No</Typography>
           <CustomInput   
           name="amount"
           type="number"
           sx={{marginTop:"0px !important"}}
          //  label="Account No"
           disabled={true}
            value={selectedAccountNumber}>
            </CustomInput>
            </>
              )}

          {/* {state.depositTo && (
          
            // <FormControl fullWidth size="small">
            //   <InputLabel>Select Account</InputLabel>
            //   <Select
            //     size="small"
            //     name="accountNumber"
            //     value={state.accountNumber}
            //     label="Select Account"
            //     onChange={handleInput}
            //   >
                // {banks.map((item, i) => {
                //   return (
                //     <MenuItem key={i} value={item}>
                //       {item.bankName}
                //     </MenuItem>
                //   );
                // })}
            //   </Select>
            // </FormControl>
          )} */}

          <CustomInput
            label="Amount"
            name="amount"
            type="number"
            value={state.amount}
            onChange={handleInput}
            onClear={() => handleClear("amount")}
          />
            <CustomInput
            label="Detail"
            name="detail"
            type="text"
            value={state.detail}
            onChange={handleInput}
            onClear={() => handleClear("amount")}
          />


          {loading && (
            <Stack alignItems="center" width="100%" justifyContent="center">
              <ClipLoader size={35} loading={true} color="#4eaf51" />
            </Stack>
          )}
          {!loading && (
            <Stack direction="row" width="100%" justifyContent="space-evenly">
              <Button
                variant="contained"
                sx={{
                  background: "#F2F2F2 !important",
                  color: "#767676",
                  textTransform: "none",
                }}
                onClick={toggle}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={handleSubmit}
              >
                Add
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddPayment;
